module.exports = __webpack_public_path__ + "static/talisman_of_the_sphere-fa816a7dbe2ee4fc819b54fc1d8ab32e.jpeg";